<template>
  <div>
    <div class="option-wrapper" role="listbox">
      <div class="mb-2 choice-wrapper" role="option">
        <div v-on:click="select($event, 'a')" class="choice-option">
          <input
            :checked="question.answer === 'a'"
            :disabled="disableAnswer"
            type="checkbox"
            value="'a"
            class="checkbox"
          />
          <div class="choice-label">
            <span>True</span>
          </div>
        </div>
      </div>
      <div
        v-on:click="select($event, 'b')"
        class="mb-2 choice-wrapper"
        role="option"
      >
        <div class="choice-option" style="background: #F7195A">
          <input
            :checked="question.answer === 'b'"
            :disabled="disableAnswer"
            value="'b"
            type="checkbox"
            class="checkbox"
          />
          <div class="choice-label">
            <span>False</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseType from "./BaseType.vue";
import { QuestionType } from "../../models/QuestionModel";

export default {
  extends: BaseType,
  name: QuestionType.TrueFalse,
  methods: {
    onEnter() {
      this.dirty = true;

      this._onEnter();
    },

    isValid() {
      return true;
    },

    select(event, value) {
      if (this.disableAnswer) {
        return;
      }
      this.onChange(value);
      const items = document.querySelectorAll(".choice-option");
      for (var i = 0; i < items.length; i++) {
        // Remove the .active class
        items[i].classList.remove("active");
      }
      this.value = !this.value;
      const el = event.target;
      el.classList.add("active");
    },
    onChange(value) {
      if (this.disableAnswer) {
        return;
      }
      this.dirty = true;
      this.dataValue = value;

      this.onKeyDown();
      this.setAnswer(this.dataValue);
    }
  },
  props: {
    disableAnswer: {
      type: Boolean,
      default: false,
    }
  }
};
</script>

<style scoped>
.option-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: row;
}

.choice-wrapper {
  display: flex;
  width: 250px;
  height: 145px;
  margin-right: 8px;
  cursor: pointer;
}

.choice-option {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px 12px;
  border-radius: 8px;
}

.choice-wrapper:last-child {
  margin-right: 0px;
}

.choice-label {
  margin: auto;
  text-align: center;
}

.label {
  width: 656px;
  display: flex;
  justify-content: center;
  margin-top: 12px;
}

.checkbox {
  position: absolute;
}

@media screen and (max-width: 580px) {
  .truefalse-options {
    height: 32px !important;
    font-size: 10px;
    padding: 4px 8px;
    margin-right: 4px;
  }
}

@media screen and (max-width: 320px) {
  .truefalse-options {
    width: 25px;
    height: 25px;
    font-size: 10px;
  }
}

.truefalse-options:last-child {
  margin-right: 0 !important;
}
</style>
